import React, { FC } from 'react';

import { propsHelperRem, SvgProps } from '@/shared/lib/propsHelper';

export const InstagramIcon: FC<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.4, props)}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.75 3.5A4.25 4.25 0 0 0 3.5 7.75v8.5a4.25 4.25 0 0 0 4.25 4.25h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5a4.25 4.25 0 0 0-4.25-4.25h-8.5ZM7.278 12a4.722 4.722 0 1 0 9.444 0 4.722 4.722 0 0 0-9.444 0ZM12 14.833a2.833 2.833 0 1 0 0-5.666 2.833 2.833 0 0 0 0 5.666Zm5.667-8.5a.944.944 0 1 1-1.89 0 .944.944 0 0 1 1.89 0Z"
            fill="#fff"
        />
    </svg>
);
